module.exports = __webpack_public_path__ + "static/media/aba-bakong.dd5362cf.svg";